import { useEffect } from 'react'
import { connect } from 'formik'
import { CodonationCalculator } from './codonation_calculator'
import { CodonationCalculatorModest } from './codonation_calculator_modest'

export const CodonationWatcher = connect(({ formik }) => {

  useEffect(() => {
    if (formik.touched.codonation_cents) return
    if (formik.values._show_codonation) {
      const calc = CodonationCalculatorModest.appliesTo(formik.values) ? CodonationCalculatorModest : CodonationCalculator
      const codonationCents = calc.suggest(formik.values.amount_cents)
      formik.setFieldValue('codonation_cents', codonationCents)
    }
  }, [formik.values.amount_cents])

  return null
})
